export const SECOND_FAZE = false;
